import React, { Component } from 'react';
import './styles.scss';
import Icon from '../Icon';
import { NavLink } from 'react-router-dom';
import { HOME } from '../../routes';

class AdminCover extends Component {
	render() {
		const { user } = this.props;
		const { firstName, lastName } = user;
		return (
			<div className="AdminCover">
				<Icon icon={'eris'} />
				<div className="AdminCover-content">
					<div className="AdminCover-user">
						<label>Welcome,</label>
						<span>
							{firstName} {lastName}
						</span>
					</div>
					<div className="AdminCover-cta">
						<NavLink to={HOME}>
							<Icon icon="logout" />
							<span>Exit</span>
						</NavLink>
					</div>
				</div>
			</div>
		);
	}
}

export default AdminCover;
